/* Cyber Day · ficha de producto: etiqueta de precio, botón de compra bajo "Incluye", envío gratis junto a la cápsula Cyber */
(function () {
  var LABEL = '🔥 Comprar ahora · Precio Cyber';
  // Sube por el árbol hasta el hijo directo de `root`
  function topChild(el, root) {
    while (el && el.parentNode !== root) el = el.parentNode;
    return el;
  }
  function run() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.__cyP) return;
    info.__cyP = true;

    var price = info.querySelector('.product-price');
    if (price && price.parentNode) {
      var lbl = document.createElement('div');
      lbl.className = 'cy-plabel';
      lbl.innerHTML = '<span></span>Precio Cyber Day';
      price.parentNode.insertBefore(lbl, price);
    }

    var form = info.querySelector('.product-form');
    if (!form) return;
    var buy = topChild(form, info);
    if (!buy) return;

    // Bloque de compra justo debajo de la lista "Incluye"
    var incl = info.querySelector('.producto-incluye');
    var anchor = incl && topChild(incl, info);
    if (!anchor) {
      var picker = info.querySelector('variant-selects, variant-radios');
      anchor = (picker && topChild(picker, info)) || (price && topChild(price, info));
    }

    // Texto persuasivo sobre el botón
    var note = document.createElement('div');
    note.className = 'cy-buynote';
    note.innerHTML = '<b>⚡ Solo en Cyber Day</b><span>Aprovecha el precio especial antes de que se agote el stock.</span>';

    if (anchor && anchor !== buy) {
      info.insertBefore(note, anchor.nextSibling);
      info.insertBefore(buy, note.nextSibling);
    } else {
      info.insertBefore(note, buy);
    }

    // Texto del botón (se reaplica si el tema lo restablece)
    var btn = form.querySelector('.product-form__submit');
    if (btn) {
      var target = btn.querySelector('span') || btn;
      var apply = function () {
        if (/agregar al carrito/i.test(target.textContent)) target.textContent = LABEL;
      };
      apply();
      new MutationObserver(apply).observe(btn, { childList: true, characterData: true, subtree: true });
    }
  }

  // Envío gratis RM: junto a la cápsula Cyber. La cápsula la inserta otro script al cargar el DOM,
  // por eso se reintenta hasta que exista.
  function ship() {
    var badge = document.querySelector('.cy-pbadge');
    var sh = document.querySelector('.shipping-badge-swich');
    if (!badge || !sh) return false;
    if (sh.parentNode === badge) return true;
    var tag = badge.querySelector('.cy-pbadge__tag');
    sh.style.setProperty('margin', '0', 'important');
    badge.insertBefore(sh, tag ? tag.nextSibling : badge.firstChild);
    return true;
  }
  function shipWhenReady() {
    var tries = 0;
    var t = setInterval(function () {
      if (ship() || ++tries > 40) clearInterval(t);
    }, 75);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  shipWhenReady();
})();
